import { Component } from '@angular/core';
import { PmDialogComponent } from '@shared/components/pm-dialog/pm-dialog.component';
import { PmErrorMessageComponent } from '@shared/components/pm-error-message/pm-error-message.component';

@Component({
  selector: 'pm-app-disabled-dialog',
  imports: [PmDialogComponent, PmErrorMessageComponent],
  templateUrl: './pm-app-disabled-dialog.component.html',
  styleUrl: './pm-app-disabled-dialog.component.scss',
})
export class PmAppDisabledDialogComponent {}
